import { COLUMNS } from './keys';
import { Component } from 'react';
import DataTable from '../../../components/Datatable';
import { scrollForTable } from '../../../components/Datatable/utils';

class PageTable extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <DataTable
                    nodes={this.props.data}
                    sortFns={{}}
                    COLUMNS={COLUMNS(this.props.default_image)}
                    fileName="Pages"
                    searchFunction={(data) => data}
                    pdfColumnSize={18}
                    onlyTable
                    hasSort={false}
                    additionalStyles={{
                        Table: `
                            --data-table-library_grid-template-columns : minmax(400px, 5fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                            ${scrollForTable}
                        `,
                        BaseCell: `font-family: 'Raleway';
                                    font-weight: 500;
                                    font-size: 16px;
                                    line-height: 19px;
                                    padding: 16px 10px;
                                    color: #0D182C;
                                
                                    &.underline {
                                        text-decoration: underline;
                                    }
                                    *{
                                        text-wrap: wrap;
                                    }
                                    `,
                        Cell: `
                            *{
                                text-wrap: wrap !important;
                            }
                        `,
                    }}
                />
            </>
        );
    }
}
export default PageTable;
